import { useTranslation } from 'react-i18next'

import { MIN_MPLUS_PRICE } from 'shared/constants'
import { AllIcons } from 'shared/ui/app-icon/types'
import { PaymentType } from 'shared/ui/payment-type'

import { DisabledMplusCard } from '../components/disabled-mplus-card'

import s from './styles.module.scss'

export const MplusPriceLess = () => {
  const { t } = useTranslation()

  return (
    <div className={s.container}>
      <PaymentType
        isActive
        icon={AllIcons.CASH}
        title={t('mplus.pay_current')}
        subTitle={t('mplus.with_trans_mbank')}
      />

      <DisabledMplusCard price={String(MIN_MPLUS_PRICE)} />
    </div>
  )
}
